import { returnGender, returnUserACTScoreOutput, returnUserSATScoreOutput } from "../dictionary"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { returnExplanationText } from "./ExplanationText"
import { useEffect, useState } from "react"
import { collegeMap } from "../collegeMap"

const returnFinalScoreAssignment = (subScores, testPolicy) => {
  let locationScore = subScores.location
  let admitRateScore = subScores.admitRate
  let finalAssignment: number = 0

  // case 1: admitRate 1
  if (admitRateScore === 1) {
    finalAssignment = 1
  }

  // case 27-51, 58-63: admitRate 2
  else if (admitRateScore === 2) {
    switch (true) {
      case testPolicy == 1:
        switch (subScores.testScores) {
          case 3:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 2;
                break
              case 2:
                finalAssignment = 2;
                break
              case 1:
                finalAssignment = 1;
                break
              case 0:
                finalAssignment = 2;
                break
              default:
                return finalAssignment
            }
            break;
          case 2:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 2;
                break
              case 2:
                finalAssignment = 2;
                break
              case 1:
                finalAssignment = 1;
                break
              case 0:
                finalAssignment = 2;
                break
              default:
                return finalAssignment
            }
            break;
          case 1:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 1;
                break
              case 2:
                finalAssignment = 1;
                break
              case 1:
                finalAssignment = 1;
                break
              case 0:
                finalAssignment = 1;
                break
              default:
                return finalAssignment
            }
            break;
          case 0:
            finalAssignment = 0;
            break
          default:
            return finalAssignment
        }
        break;
      case testPolicy == 2:
        switch (subScores.testScores) {
          case 3:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 2
                break;
              case 2:
                finalAssignment = 2
                break;
              case 1:
                finalAssignment = 1
                break;
              case 0:
                finalAssignment = 2;
                break
              default:
                return finalAssignment
            }
            break;
          case 2:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 2
                break;
              case 2:
                finalAssignment = 2
                break;
              case 1:
                finalAssignment = 1
                break;
              case 0:
                finalAssignment = 2;
                break
              default:
                return finalAssignment
            }
            break;
          case 1:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 2
                break;
              case 2:
                finalAssignment = 2
                break;
              case 1:
                finalAssignment = 1
                break;
              case 0:
                finalAssignment = 1;
                break
              default:
                return finalAssignment
            }
            break;
          case 0:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 2
                break;
              case 2:
                finalAssignment = 2
                break;
              case 1:
                finalAssignment = 1
                break;
              default:
                return finalAssignment
            }
            break;
          default:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 2
                break;
              case 2:
                finalAssignment = 2
                break;
              case 1:
                finalAssignment = 1
                break;
              default:
                return finalAssignment
            }
            break;
        }
        break;
      case testPolicy == 3:
        switch (subScores.grades) {
          case 3:
            finalAssignment = 2
            break;
          case 2:
            finalAssignment = 2
            break;
          case 1:
            finalAssignment = 1
            break;
          default:
            return finalAssignment
        }
        break
      default:
        return finalAssignment
    }
  }

  // case 2-26, 52-57: admitRate 3
  else if (admitRateScore === 3) {
    switch (true) {
      case testPolicy == 1:
        switch (subScores.testScores) {
          case 3:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 3;
                break
              case 2:
                finalAssignment = 3;
                break
              case 1:
                finalAssignment = 1;
                break
              case 0:
                finalAssignment = 3;
                break
              default:
                return finalAssignment
            }
            break;
          case 2:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 3;
                break
              case 2:
                finalAssignment = 2;
                break
              case 1:
                finalAssignment = 1;
                break
              case 0:
                finalAssignment = 2;
                break
              default:
                return finalAssignment
            }
            break;
          case 1:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 1;
                break
              case 2:
                finalAssignment = 1;
                break
              case 1:
                finalAssignment = 1;
                break
              case 0:
                finalAssignment = 1;
                break
              default:
                return finalAssignment
            }
            break;
          case 0:
            finalAssignment = 0;
            break
          default:
            return finalAssignment
        }
        break;
      case testPolicy == 2:
        switch (subScores.testScores) {
          case 3:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 3
                break;
              case 2:
                finalAssignment = 3
                break;
              case 1:
                finalAssignment = 1
                break;
              case 0:
                finalAssignment = 3;
                break
              default:
                return finalAssignment
            }
            break;
          case 2:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 3
                break;
              case 2:
                finalAssignment = 2
                break;
              case 1:
                finalAssignment = 1
                break;
              case 0:
                finalAssignment = 2;
                break
              default:
                return finalAssignment
            }
            break;
          case 1:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 2
                break;
              case 2:
                finalAssignment = 2
                break;
              case 1:
                finalAssignment = 1
                break;
              case 0:
                finalAssignment = 1;
                break
              default:
                return finalAssignment
            }
            break;
          case 0:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 3
                break;
              case 2:
                finalAssignment = 2
                break;
              case 1:
                finalAssignment = 1
                break;
              default:
                return finalAssignment
            }
            break;
          default:
            switch (subScores.grades) {
              case 3:
                finalAssignment = 3
                break;
              case 2:
                finalAssignment = 2
                break;
              case 1:
                finalAssignment = 1
                break;
              default:
                return finalAssignment
            }
            break;
        }
        break;
      case testPolicy == 3:
        switch (subScores.grades) {
          case 3:
            finalAssignment = 3
            break;
          case 2:
            finalAssignment = 2
            break;
          case 1:
            finalAssignment = 1
            break;
          default:
            return finalAssignment
        }
        break;
      default:
        return finalAssignment
    }
  }

  // Rule 64
  if ((admitRateScore === 2 || admitRateScore === 3) && subScores.testScores === 0 && subScores.grades === 0) {
    finalAssignment = 0
  }

  // Rule 65 / 66
  if ([2, 3].includes(admitRateScore) && testPolicy == 3 && [1, 2, 3].includes(subScores.testScores) && subScores.grades === 0) {
    finalAssignment = 0
  }

  if (finalAssignment > 1 && locationScore == 1) {
    finalAssignment = finalAssignment - 1
  }

  return finalAssignment
}

const returnPersonalizedFit = (college, user, userCollegeInterest, returnSubscore = false) => {

  let subScores = {
    'admitRate': 0,
    'testScores': 0,
    'gpa': 0,
    'classRank': 0,
    'grades': 0,
    'location': 0,
  }

  // #1457 explanation text clause values
  let ttDescriptors: any = {
    testScore: null,
    testScoreCorr: null,
    grades: null,
    gradesCorr: null,
    admit: null,
    fit: null
  }

  // Admit Rate
  const updateAdmitRateSubScore = (college, user) => {
    const cdsData = college?.college_cds?.[0];

    if (!cdsData) return;

    let referenceAdmitRate = cdsData.totalAdmitRate * 100;
    ttDescriptors.admit = 'overall admit rate';

    if (user?.gender && user?.gender != 'Not specified') {
      let userGender = returnGender(user?.gender)
      switch (true) {
        case user?.gender == '1' && cdsData.menAdmitRate != null:
        case user?.gender == 1 && cdsData.menAdmitRate != null:
          ttDescriptors.admit = 'male admit rate';
          break
        case user?.gender == '2' && cdsData.womenAdmitRate != null:
        case user?.gender == 2 && cdsData.womenAdmitRate != null:
          ttDescriptors.admit = 'female admit rate';
          break
        case user?.gender == '4' && cdsData.otherAdmitRate != null:
        case user?.gender == 4 && cdsData.otherAdmitRate != null:
          ttDescriptors.admit = 'other admit rate';
          break
      }
      const genderMap = {
        'Male': cdsData.menAdmitRate != null ? cdsData.menAdmitRate * 100 : referenceAdmitRate,
        'Female': cdsData.womenAdmitRate != null ? cdsData.womenAdmitRate * 100 : referenceAdmitRate,
        'Other': cdsData.otherAdmitRate != null ? cdsData.otherAdmitRate * 100 : referenceAdmitRate
      };

      referenceAdmitRate = genderMap[userGender] ?? referenceAdmitRate
    }

    if (referenceAdmitRate <= 15) {
      subScores.admitRate = 1
    } else if (15 < referenceAdmitRate && referenceAdmitRate < 33.3) {
      subScores.admitRate = 2
    } else if (referenceAdmitRate >= 33.3) {
      subScores.admitRate = 3
    }

  }
  updateAdmitRateSubScore(college, user)

  let testScoreRefScoreOutput: any = undefined
  // Test Scores
  const updateTestScoresSubScore = (college, user) => {
    let satScoreOutput: any
    let actScoreOutput: any
    let ttDescriptorsTestScore: any = []

    const satCheck = user?.satMath != undefined && user?.satMath != null && user?.satVerbal != undefined && user?.satVerbal != null

    const actCheck = user?.actComposite != undefined && user?.actComposite != null

    if (satCheck) {
      ttDescriptorsTestScore.push('sat');
      satScoreOutput = returnUserSATScoreOutput(user?.satMath, user?.satVerbal, college)
    }

    if (actCheck) {
      ttDescriptorsTestScore.push('act');
      actScoreOutput = returnUserACTScoreOutput(user?.actComposite, college)
    }

    if (ttDescriptorsTestScore.includes('sat') && ttDescriptorsTestScore.includes('act')) {
      ttDescriptors.testScore = 'SAT & ACT scores';
      ttDescriptors.testScoreCorr = 'are'
    } else if (ttDescriptorsTestScore.includes('sat') && !ttDescriptorsTestScore.includes('act')) {
      ttDescriptors.testScore = 'SAT score';
      ttDescriptors.testScoreCorr = 'is'
    } else if (ttDescriptorsTestScore.includes('act') && !ttDescriptorsTestScore.includes('sat')) {
      ttDescriptors.testScore = 'ACT score';
      ttDescriptors.testScoreCorr = 'is'
    }

    const cleanedSat = isNaN(satScoreOutput) ? -Infinity : satScoreOutput;
    const cleanedAct = isNaN(actScoreOutput) ? -Infinity : actScoreOutput;

    const referenceOutputScore = Math.max(cleanedSat, cleanedAct);

    if (referenceOutputScore >= 75) {
      subScores.testScores = 3
    } else if (35 <= referenceOutputScore && referenceOutputScore < 75) {
      subScores.testScores = 2
    } else if (0 <= referenceOutputScore && referenceOutputScore < 35) {
      subScores.testScores = 1
    } else if (referenceOutputScore < 0) {
      subScores.testScores = 0
    }
  }

  if ((user?.satMath && user?.satVerbal) || user?.actComposite) {
    updateTestScoresSubScore(college, user)
  }

  // GPA
  const updateGPASubScore = (college, user) => {
    let userGPA = user?.gpaUnweighted
    let cdsData = college?.college_cds?.[0]
    let collegeAverageGPA = college?.college_cds?.[0]?.averageGPA

    if (userGPA === null || userGPA === undefined) return

    if (userGPA >= (collegeAverageGPA + 0.10)) {
      subScores.gpa = 3
    } else if ((collegeAverageGPA - 0.05) < userGPA && userGPA < (collegeAverageGPA + 0.10)) {
      subScores.gpa = 2
    } else if (userGPA <= (collegeAverageGPA - 0.05)) {
      subScores.gpa = 1
    }
  }

  if (college?.college_cds?.[0]?.averageGPA != null && college?.college_cds?.[0]?.gpaAverageType === 0) {
    updateGPASubScore(college, user)
  }

  // Class Rank
  const updateClassRankSubScore = (college, user) => {
    let classRankTopTenth = college?.college_cds?.[0]?.classRankTopTenth
    let userClassRank: any
    if (user?.classRankNumber && user?.classRankSize) {
      userClassRank = user?.classRankNumber / user?.classRankSize
    } else {
      const convertClassRankTier = (val) => {
        switch (val) {
          // top 1%
          case 1:
            return 0.01;
          // top 5%
          case 2:
            return 0.05;
          // top 10%
          case 3:
            return 0.10;
          // top 25%
          case 4:
            return 0.25;
          // top 50%
          case 5:
            return 0.50;
          // bottom 50%
          case 6:
            return 0.75;
          default:
            subScores.classRank = 0
        }
      }
      userClassRank = convertClassRankTier(user?.classRankTier)
    }

    // 1)
    if (classRankTopTenth >= 0.9) {
      if (userClassRank <= 0.05) {
        subScores.classRank = 2
      } else if (userClassRank > 0.05) {
        subScores.classRank = 1
      }
    }

    // 2)
    else if (0.7 <= classRankTopTenth && classRankTopTenth < 0.9) {
      if (userClassRank <= 0.10) {
        subScores.classRank = 2
      } else if (userClassRank > 0.10) {
        subScores.classRank = 1
      }
    }

    // 3)
    else if (0.5 <= classRankTopTenth && classRankTopTenth < 0.7) {
      if (userClassRank <= 0.05) {
        subScores.classRank = 3
      } else if (0.05 < userClassRank && userClassRank <= 0.25) {
        subScores.classRank = 2
      } else if (userClassRank > 0.25) {
        subScores.classRank = 1
      }
    }

    // 4)
    else if (classRankTopTenth < 0.5) {
      if (userClassRank <= 0.10) {
        subScores.classRank = 3
      } else if (0.10 < userClassRank && userClassRank <= 0.25) {
        subScores.classRank = 2
      } else if (userClassRank > 0.25) {
        subScores.classRank = 1
      }
    }

    // 5) default case
  }

  if (college?.college_cds?.[0]?.classRankTopTenth != null && ((user?.classRankNumber && user?.classRankSize) || user?.classRankTier)) {
    updateClassRankSubScore(college, user)
  }

  // Grades
  const updateGradesSubScore = (subScores) => {

    let userGPA = user?.gpaUnweighted;
    let userGPAExists = true
    if (userGPA === null || userGPA === undefined) {
      userGPAExists = false
    }
    if (subScores.gpa == subScores.classRank) {
      // GPA subscore and class rank subscore are equal--
      ttDescriptors.grades = userGPAExists ? 'unweighted GPA & class rank' : 'class rank';
      ttDescriptors.gradesCorr = userGPAExists ? 'are' : 'is';
      subScores.grades = subScores.classRank
    } else if (subScores.classRank == 0 && subScores.gpa > 0) {
      // grades subScore based on gpa--
      ttDescriptors.grades = 'unweighted GPA';
      ttDescriptors.gradesCorr = 'is';
      subScores.grades = subScores.gpa
    } else if (subScores.gpa == 0 && subScores.classRank > 0) {
      // grades subScore based on classRank--
      ttDescriptors.grades = 'class rank';
      ttDescriptors.gradesCorr = 'is';
      subScores.grades = subScores.classRank
    } else if (subScores.classRank > 0 && subScores.gpa > 0) {
      if (subScores.classRank > subScores.gpa) {
        // ttDescriptors.grades = 'class rank';
        // ttDescriptors.gradesCorr = 'is';

        ttDescriptors.grades = 'unweighted GPA';
        ttDescriptors.gradesCorr = 'is';
      } else if (subScores.classRank < subScores.gpa) {
        // ttDescriptors.grades = 'unweighted GPA';
        // ttDescriptors.gradesCorr = 'is';

        ttDescriptors.grades = 'class rank';
        ttDescriptors.gradesCorr = 'is';
      }
      subScores.grades = Math.min(subScores.classRank, subScores.gpa)
    }
  }
  updateGradesSubScore(subScores)

  // Location (State)
  const updateLocationSubScore = (college, user) => {
    let collegeLocation = college?.locationState
    let userLocation = user?.state
    let isPublic = college.type == 1

    if (isPublic && (collegeLocation != userLocation)) {
      subScores.location = 1
    } else if (isPublic && (collegeLocation == userLocation)) {
      subScores.location = 2
    }
  }
  updateLocationSubScore(college, user)

  // set same val as PersonalizedFit filter component setter
  let finalScore = !!(user && (user.gpaUnweighted != null || user.classRankNumber != null || user.classRankTier != null)) ? returnFinalScoreAssignment(subScores, college?.testPolicy) : null

  if (returnSubscore) {
    // const finalAssignment = returnPersonalizedFit(college, user, userCollegeInterest);

    const rawSavedFit = userCollegeInterest.find((c) => c.college_id === college.id)?.fit;

    const userSavedFit = Number.isInteger(rawSavedFit) ? rawSavedFit - 1 : null;

    const trueAssignment: any = userSavedFit !== null ? userSavedFit : finalScore;

    const scoreMap = {
      0: 'Unknown',
      1: 'Reach',
      2: 'Target',
      3: 'Safety'
    }

    ttDescriptors.fit = scoreMap[trueAssignment]

    let matchingUserCollegeInterest = userCollegeInterest.find((col) => `${col.college_id}` == `${college.id}`)
    const collegeName = collegeMap.find((col) => `${col.id}` == `${college.id}`)?.name

    let subScoreTooltip = (
      <div className="dca-fit-tooltip-content-mobile">
        {/* <ul>
          <li>Admit Rate: {subScores.admitRate}</li>
          <li>Test Scores: {subScores.testScores}</li>
          <li>GPA: {subScores.gpa}</li>
          <li>Class: {subScores.classRank}</li>
          <li>Grades: {subScores.grades}</li>
          <li>Location: {subScores.location}</li>
          <li>Final Score: {finalScore}</li>
        </ul> */}
        {matchingUserCollegeInterest?.userSelected ? <span>You indicated {collegeName} as a {scoreMap[matchingUserCollegeInterest?.fit - 1]} in your saved college interest list. You may adjust this designation on the User Profile page.</span> : <span>{returnExplanationText(college, ttDescriptors, subScores)}</span>}
      </div>
    )
    return subScoreTooltip
  }

  return finalScore
}

const PersonalizedFitIndicator = ({ college, user, userCollegeInterest, mobile = false }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleToggleTooltip = () => setShowTooltip(prev => !prev);
  const handleHideTooltip = () => setShowTooltip(false);

  const scoreMap = {
    0: 'Unknown',
    1: 'Reach',
    2: 'Target',
    3: 'Safety'
  };

  const subScoreTooltip = returnPersonalizedFit(college, user, userCollegeInterest, true);
  const finalAssignment = returnPersonalizedFit(college, user, userCollegeInterest);
  const rawSavedFit = userCollegeInterest.find((c) => c.college_id === college.id)?.fit;
  const userSavedFit = Number.isInteger(rawSavedFit) ? rawSavedFit - 1 : null;
  const trueAssignment = userSavedFit !== null ? userSavedFit : finalAssignment;

  const [delayedAssignment, setDelayedAssignment] = useState<any>(trueAssignment);

  // #1449 set a delay timer on usercollegeinterest list, persist return while fit changes from default
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDelayedAssignment(trueAssignment);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [userCollegeInterest]);

  return (!Number.isInteger(delayedAssignment) || !(delayedAssignment in scoreMap)) ? null : (
    <div className={`dca-fit-wrapper ${mobile ? 'mobile' : ''}`}>
      {mobile ? <div
        className={`dca-personalized-fit-indicator ${scoreMap[delayedAssignment]} ${mobile ? 'mobile' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          handleToggleTooltip();
        }}
      >
        {scoreMap[delayedAssignment]}
      </div> : <div
        className={`dca-personalized-fit-indicator ${scoreMap[delayedAssignment]} ${mobile ? 'mobile' : ''}`}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {scoreMap[delayedAssignment]}
      </div>}

      <OverlayTrigger
        overlay={(props) => (
          <Tooltip {...props} className="dca-tooltip">
            {subScoreTooltip}
            {mobile ? <span
              style={{
                position: 'absolute',
                top: '2px',
                right: '15px',
                cursor: 'pointer',
                color: 'white',
                zIndex: 1001,
                fontSize: '25px',
                height: '100%',
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleHideTooltip();
              }}
            >
              &times;
            </span> : <></>}
          </Tooltip>
        )}
        placement="top"
        popperConfig={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            },
          ],
        }}
        show={showTooltip}
      >
        {mobile ? <span
          className={`dca-personalized-fit-indicator-tooltip mobile ${scoreMap[delayedAssignment]}`}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleToggleTooltip();
          }}
        >
          <i
            className="bi bi-info-circle-fill"
            style={{ color: 'black' }}
          ></i>
        </span> : <span
          className={`dca-personalized-fit-indicator-tooltip ${scoreMap[delayedAssignment]}`}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <i
            className="bi bi-info-circle-fill"
            style={{ color: 'black' }}
          ></i>
        </span>}
      </OverlayTrigger>
    </div>

  );
};

export { PersonalizedFitIndicator, returnPersonalizedFit }